/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ReportingMonetizationTrialStatus represents the current status of a reporting-monetization trial.   - REPORTING_MONETIZATION_STATUS_UNSPECIFIED: Unspecified default value.  - REPORTING_MONETIZATION_STATUS_TRIAL_PENDING: Organization is eligible but the trial has not yet started.  - REPORTING_MONETIZATION_STATUS_TRIAL_ACTIVE: Trial is currently running.  - REPORTING_MONETIZATION_STATUS_TRIAL_EXPIRED: Trial period has ended.  - REPORTING_MONETIZATION_STATUS_PAID: Organization paid for reporting.  not used for now  - REPORTING_MONETIZATION_STATUS_PAYMENT_EXPIRED: Organization stopped paying for reporting.  not used for now
 * @export
 * @enum {string}
 */

export const CostreportV1beta1ReportingMonetizationStatus = {
    UNSPECIFIED: 'REPORTING_MONETIZATION_STATUS_UNSPECIFIED',
    TRIAL_PENDING: 'REPORTING_MONETIZATION_STATUS_TRIAL_PENDING',
    TRIAL_ACTIVE: 'REPORTING_MONETIZATION_STATUS_TRIAL_ACTIVE',
    TRIAL_EXPIRED: 'REPORTING_MONETIZATION_STATUS_TRIAL_EXPIRED',
    PAID: 'REPORTING_MONETIZATION_STATUS_PAID',
    PAYMENT_EXPIRED: 'REPORTING_MONETIZATION_STATUS_PAYMENT_EXPIRED'
} as const;

export type CostreportV1beta1ReportingMonetizationStatus = typeof CostreportV1beta1ReportingMonetizationStatus[keyof typeof CostreportV1beta1ReportingMonetizationStatus];



